import React from 'react';
import styled from 'styled-components';
import Button from '@gcc/pip-components/dist/Button';
import { getConfig } from '../config';

const ProductNotAvailableContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
  margin-top: 20px;
  flex-direction: column;

  .message-wrapper {
     padding: 20px 20px 20px 20px;
     background: #FFC20E;
     @media(max-width: 575px) {
      padding: 10px 10px 10px 10px;
     }
     margin-bottom: 20px;
  }

  .header {
    font-size: 2.4rem;
    font-weight:  bold;
    padding-bottom: 10px;
  }

  .message {
    font-size: 1.4rem;
  }
`;

const ProductNotAvailable = () => (
  <div>
    <ProductNotAvailableContainer>
      <div className="message-wrapper">
        <div className="header">
          Product Not Available
        </div>
        <div>
          Based on your store selection above, this surface isn&apos;t available in your area.
          Verify your location or choose another custom countertop surface.
        </div>
      </div>
      <Button
        className="primary bttn-primary-pip"
        onClick={() => { window.location = getConfig()?.countertopsCategoryPageUrl; }}
      >
        Choose Another Surface
      </Button>
    </ProductNotAvailableContainer>

  </div>
);

export default ProductNotAvailable;
